import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import VxBasicInputField from '../vxFields/VxBasicInputField';
import VxRadioField from '../vxFields/VxRadioField';
import getLocaleMessages from '../../utils/localesMessages';
import LogoPreview from '../logo/LogoPreview';

const {
	input: {
		logoURLStr,
		logoURLMandatoryStr
	},
	useSettingsLogo: useSettingsLogoLabel,
	useAnotherLogo: useAnotherLogoLabel,
	useLogoOrUpload,
	enterAUrl
} = getLocaleMessages('buttons/wizardStepTwo');

class LogoComponent extends Component {
	static propTypes = {
		logoUrl: PropTypes.string,
		settingsLogoUrl: PropTypes.string,
		useSettingsLogo: PropTypes.string,
		country: PropTypes.string
	}

	renderTextField = (props) => {
		return (
			<VxBasicInputField {...props} />
		)
	}

	renderLogoPreview = (previewUrl) => {
		return <LogoPreview
			logoImageUrl={previewUrl}
		/>
	}

	renderRadioField = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}

	render() {
		const {
			logoUrl,
			useSettingsLogo,
			settingsLogoUrl			
		} = this.props;


		return (
			<div className="logo-component">
				<div className="logo-preview">
					<div className="logo-note">
						{settingsLogoUrl ? useLogoOrUpload : enterAUrl}
					</div>
				</div>
				{
					settingsLogoUrl ?
					<div className="input-block">
						<Field
							type="radio"
							id="useSettingsLogo"
							name="useSettingsLogo"
							value="yes"
							checkedValue={useSettingsLogo}
							component={this.renderRadioField}
							label={useSettingsLogoLabel}
						/>
						{
							useSettingsLogo === 'yes' &&
							<div className="fields-margin-left settings-logo">
								{this.renderLogoPreview(settingsLogoUrl)}
							</div>
						}
						
						<Field
							type="radio"
							id="uploadNewLogo"
							name="useSettingsLogo"
							value="no"
							checkedValue={useSettingsLogo}
							component={this.renderRadioField}
							label={useAnotherLogoLabel}
						/>
						{
							useSettingsLogo === 'no' &&
							<div className="fields-margin-left">
								{this.renderLogoPreview(logoUrl)}
								<Field
									id="logoUrl"
									name="logoUrl"
									type="text"
									component={this.renderTextField}
									label={logoURLMandatoryStr || logoURLStr}
								/>
							</div>
						}
						
					</div> :
					<div className="input-block">
						{this.renderLogoPreview(logoUrl)}
						<Field
							id="logoUrl"
							name="logoUrl"
							type="text"
							component={this.renderTextField}
							label={logoURLStr}
						/>
					</div>
				}
				
			</div>
		);
	}
}

export default LogoComponent;



// WEBPACK FOOTER //
// ./buttons/components/logo/LogoComponent.js